import equals from "ramda/es/equals";
import last from "ramda/es/last";
import values from "ramda/es/values";
import { map as rxMap, share, withLatestFrom } from 'rxjs/operators';
import { createFieldRecord } from '../../../utils/data';
import { actionNames as controlActions } from '../../transfer/control';
import { updateValidationResultMultiple, validationRunner } from '../../transfer/transmission';
import { filterByActionType } from '../../utils';
export default (({ control$, globalErrors$ })=>control$.pipe(filterByActionType(controlActions.REMOVE_FROM_LIST), withLatestFrom(globalErrors$), rxMap(([{ payload }, globalErrors])=>{
        const result = {};
        // fastest yet ugliest solution
        values(globalErrors).forEach((records)=>{
            const record = records?.[0];
            if (record && equals(record.arrayDeepPath, payload.deepPath) && last(record.fieldIndices) >= payload.index) {
                const originalRecordFieldIndices = record.fieldIndices;
                const originalRecordName = createFieldRecord(record.fieldName, originalRecordFieldIndices);
                if (!result[originalRecordName]) {
                    // cleanup of previous validations
                    result[originalRecordName] = [];
                }
                if (last(originalRecordFieldIndices) !== payload.index) {
                    const nextRecordFieldIndices = last(originalRecordFieldIndices) - 1;
                    // is it safe now?
                    records.forEach((rec)=>{
                        rec.fieldIndices = [
                            ...rec.fieldIndices.slice(0, -1),
                            nextRecordFieldIndices
                        ];
                    });
                    result[createFieldRecord(records[0].fieldName, records[0].fieldIndices)] = records;
                }
            }
        });
        return updateValidationResultMultiple(result, validationRunner.ALL);
    }), share()));
